module.exports = require("babel-runtime/helpers/asyncToGenerator");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/asyncToGenerator"
// module id = 82
// module chunks = 0 1 2 3 4 5 6 7